import axios from 'axios'

export default {
  getUsers ( params, callback ) {
    axios.get('/users', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getUser ( userId, callback, fallback ) {
    axios.get('/users/' + userId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/users', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( userId, data, callback, fallback ) {
    axios.post( '/users/' + userId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( userId, callback, fallback ) {
    axios.delete( '/users/' + userId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteMany ( userIds, callback, fallback ) {
    axios.post( '/users/delete', { ids: userIds })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  updateUserAccount ( data, callback, fallback ) {
    axios.post( '/user', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  saveCompany ( data, callback, fallback ) {
    axios.post( '/user/company', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getNotifications ( userId, callback ) {
    callback([]);
    /*
    axios.get('/users/' + userId + '/notifications')
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
      */
  },
  getRelatedComments ( callback, fallback ) {
    axios.get('/user/related-comments' )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  updateComment ( commentId, data, callback, fallback ) {
    axios.post('/user/comment/' + commentId, data)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getXeroInfo ( callback, fallback ) {
    axios.get('/xero/info')
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
}
